import type { GetCartRequest, UpdateCartItemRequest } from './types';

export const CART_QUERY_KEYS = {
  default: () => ['cart'] as const,
  getCart: ({ currency, sessionKey }: Pick<GetCartRequest, 'currency' | 'sessionKey'>) =>
    [...CART_QUERY_KEYS.default(), 'getCart', currency, sessionKey] as const,
  addToCart: () => [...CART_QUERY_KEYS.default(), 'addToCart'] as const,
  updateCartItem: (params?: UpdateCartItemRequest) => [...CART_QUERY_KEYS.default(), 'updateCartItem', params] as const,
  removeCartItem: () => [...CART_QUERY_KEYS.default(), 'removeCartItem'] as const,
  applyCoupon: () => [...CART_QUERY_KEYS.default(), 'applyCoupon'] as const,
  removeCoupon: () => [...CART_QUERY_KEYS.default(), 'removeCoupon'] as const,
};
